import { createNode } from '@glueapp/graph-types';
import { SlackIntegration } from './SlackIntegration';

export const SlackMessageReceived = createNode({
    triggerType: 'Integration',
    hideInherentInPort: true,
    id: 'Slack: Message Received',
    name: 'Slack: Message Received',
    description: 'Triggers when a slack message is received on the selected channel',
    aiDescription:
        'Trigger node that fires when a new message is posted in the selected Slack channel. Requires the Slack integration to be connected. The channel is selected via the slack-channel-selector interface component, which stores the selection in node state. Outputs a "Message" (string) port containing the text of the received message.',
    category: 'Slack',
    color: '#4a154b',
    triggerEventIdentifier: 'SlackMessageReceived',
    integration: SlackIntegration,
    inPorts: {
        Channel: { kind: 'string' },
    },
    outPorts: {
        Message: { kind: 'string' },
    },
    interfaceComponentId: 'slack-channel-selector',
    execute: function (input) {
        return {
            output: {
                Message: input.payload.text,
            },
        };
    },
});
